
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {getConfig, getOrderExcel, getOrderList, getOverviewExcel} from '@/services/api';
  import store from "@/store";
  import {ReportOrderReq, ReportOrderResp} from "@/model/Report";
  import {dateFormat, handleExcelRes} from "@/services/common";

  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class ReportOrder extends Vue {
    // 控制列表高度
    public tableHeight: number = window.innerHeight - 220;
    // 地区
    public countryList: {code: string, name: string}[] = [];
    // 订单状态
    public orderStatusList: {code: string, name: string}[] = [];
    // 列表数据
    public tableData: ReportOrderResp[] = [];
    // 日期
    public date: string[] = [dateFormat(new Date(), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')];
    // 上传表单
    public formData: ReportOrderReq = {
      pageNum: 1,
      pageSize: 20
    }
    indexInfo = {
      pageNum: 1,
      pageSize: 20
    }
    // 列表总数
    public totalNum = 0;
    // excel下载截流控制
    public excelCtrl = true;

    public pickerOptions = {
      shortcuts: [{
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
    }
    /**
     * 初始化方法
     */
    async created(): Promise<void> {
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 220;
        } catch (e) {}
      }
      await this.getOrderList();
      this.getConfig();
    }

    async getOrderList() {
      this.formData.startDate = this.date && this.date[0];
      this.formData.endDate = this.date && this.date[1];
      await getOrderList(this.formData).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.totalNum =  res.data.data.total || 0;
          this.indexInfo = {
            pageNum: this.formData.pageNum,
            pageSize: this.formData.pageSize
          };
        } else {
          this.$message.error(res.data.message);
        }
      })
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.region || this.$store.state.region.length === 0) {
        getConfig({type: 'region'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.countryList = res.data.result || [];
            store.commit('SET_REGION', this.countryList);
          }
        })
      } else {
        this.countryList = this.$store.state.region;
      }
      if (!this.$store.state.orderStatus || this.$store.state.orderStatus.length === 0) {
        getConfig({type: 'orderStatus'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.orderStatusList = res.data.result || [];
            store.commit('SET_ORDER_STATUS', this.orderStatusList);
          }
        })
      } else {
        this.orderStatusList = this.$store.state.orderStatus;
      }
    }

    /**
     * 数据导出
     */
    async getExcel(): Promise<void>  {
      if (this.excelCtrl) {
        this.excelCtrl = false;
        try {
          await getOrderExcel(this.formData).then((res: any) => {
            handleExcelRes(res);
          })
        } catch (e) {}
        this.excelCtrl = true;
      }
    }

    /**
     * 重置
     */
    reset(): void {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
      };
      this.date = [dateFormat(new Date(), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')];
    }

    /**
     * 查询
     */
    search(): void {
      this.formData.pageNum = 1;
      this.getOrderList();
    }

    /**
     * 分页大小变化
     * @param val
     */
    handleSizeChange(val: number): void {
      this.formData.pageSize = val;
      this.formData.pageNum = 1;
      this.getOrderList();
    }

    /**
     * 当前页面变化
     * @param val
     */
    handleCurrentChange(val: number): void {
      this.formData.pageNum = val;
      this.getOrderList();
    }

    /**
     * 序号控制
     * @param index
     */
    indexMethod(index: number) {
      return (this.indexInfo.pageNum - 1) * this.indexInfo.pageSize + index + 1;
    }

  }

